/* chagual-revie-inline.v1.js
   - El H1 y el app-block de Revie ya llegan juntos desde Liquid.
   - Este archivo solo normaliza el enlace y el conteo ante re-renders de Revie.
*/
(() => {
  const REVIE_TARGET = '#cont-rl-w';
  const SELECTOR_ROW = '[data-chagual-revie-inline]';
  const SELECTOR_BLOCK = 'div.shopify-app-block';

  const getFirstNumber = (txt) => String(txt || '').match(/\d+/)?.[0] || '';

  const normalizeRevieLink = (anchor) => {
    if (!anchor) return false;
    if (anchor.getAttribute('href') !== REVIE_TARGET) anchor.setAttribute('href', REVIE_TARGET);
    return true;
  };

  const normalizeInlineRevie = (row) => {
    if (!row) return false;

    const block = row.querySelector(SELECTOR_BLOCK);
    if (!block) return false;
    const a = block.querySelector('a.revie-aref');
    if (!a) return false;
    normalizeRevieLink(a);

    // El span es la fuente inequívoca del conteo. Si Revie cambia su HTML,
    // se conserva su salida original en vez de adivinar otro número.
    const span = block.querySelector('#rvst span') || a.querySelector('span');
    if (!span) return true;

    const n = getFirstNumber(span.textContent);
    if (!n) return true;
    const desired = `(${n})`;
    if (span.textContent !== desired) span.textContent = desired;

    return true;
  };

  const boot = () => {
    const row = document.querySelector(SELECTOR_ROW);
    if (!row) return;

    normalizeInlineRevie(row);

    if (typeof MutationObserver !== 'function') return;
    const observer = new MutationObserver(() => normalizeInlineRevie(row));
    observer.observe(row, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['href']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Debug manual (opcional)
  window.CHAGUAL_REVIE_DEBUG = () => {
    const row = document.querySelector(SELECTOR_ROW);
    const block = row?.querySelector(SELECTOR_BLOCK);
    console.log('[CHAGUAL_REVIE_DEBUG] block', block?.id);
    console.log('[CHAGUAL_REVIE_DEBUG] a.text', block?.querySelector('a.revie-aref')?.textContent);
    console.log('[CHAGUAL_REVIE_DEBUG] span.text', block?.querySelector('#rvst span')?.textContent);
    return normalizeInlineRevie(row);
  };
})();
